export default __webpack_public_path__ + "static/media/review-p.cd5c89b6.png";